import React, { useEffect, useState } from 'react';
import { GlobalState, UI } from '@leverege/ui-redux';
import { Flex, Selector } from '@leverege/ui-elements';
import Molten from '@leverege/molten';
import { getCompanyAndLocationIdsFromUrl } from '../../util/Url';
import S from './CarMaxZoneSearch.css';

// import S from './DeviceInput.css'
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VALUE_KEY = 'carMaxZoneEditor.value';
export default function CarMaxZoneSearch(props) {
  const {
    onChange,
    value
  } = props;
  const [options, setOptions] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(value);
  const [fetchedZoneData, setFetchedZoneData] = useState([]);
  const onDropdownChange = async evt => {
    setSelected(evt.value);
    GlobalState.dispatch(UI.set(VALUE_KEY, evt.value));
    onChange(fetchedZoneData.get(evt.value));
  };
  useEffect(() => {
    async function fetchZones() {
      let nApi;
      const currentPath = GlobalState.get().router?.location.pathname;
      const systemId = Molten.getConfig('api/systemId');
      const {
        locationId,
        companyId
      } = getCompanyAndLocationIdsFromUrl(currentPath);
      const zoneData = await GlobalState.dispatch(async (_dispatch, _getState, {
        api
      }) => {
        if (locationId && companyId) {
          nApi = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(locationId);
        } else {
          nApi = api.interface(systemId, 'location').obj(locationId);
        }
        return nApi.srv('recovrCarmaxServer').post('kmxZones', {});
      });

      // map zone data such that it can be accessed by the options name
      const map = new Map();
      const optionsList = zoneData.map(zone => {
        const name = `${zone.name} ${zone.kmxId} ${zone.barcode} ${zone.zoneType}`;
        map.set(name, zone);
        return {
          name
        };
      });
      setFetchedZoneData(map);
      setOptions(optionsList);
      setLoading(false);
    }
    if (fetched === false) {
      GlobalState.dispatch(UI.set(VALUE_KEY, 'none'));
      fetchZones();
      setFetched(true);
    }
  }, [fetched]);
  const selectorRenderer = (value, _selectorLabel) => {
    // helper function to split string into chunks of whole words max 25 characters
    const splitString = (str, lineLength) => {
      const arr = [''];
      str.split(' ').forEach(word => {
        if (arr[arr.length - 1].length + word.length > lineLength) arr.push('');
        arr[arr.length - 1] += `${word} `;
      });
      return arr.map(v => v.trim());
    };
    const zone = fetchedZoneData.get(value.name);
    const zoneType = zone?.zoneType ? `(${zone?.zoneType})` : undefined;
    const chunks = splitString(zone.name, 35);
    return /*#__PURE__*/_jsxs("div", {
      className: S.item,
      children: [chunks?.map(chunk => /*#__PURE__*/_jsxs("b", {
        children: [chunk, /*#__PURE__*/_jsx("br", {})]
      })), zone?.kmxId, " ", zone?.barcode || zoneType ? '|' : '', " ", zone?.barcode || '', " ", zoneType || '']
    });
  };
  const selectedTitle = selected => {
    const selectedInfo = selected.split(' ');
    const name = selectedInfo.slice(0, -3).join(' ');
    return `${name} - ${selectedInfo.at(-3)}`;
  };
  return /*#__PURE__*/_jsx("div", {
    className: S.div,
    children: /*#__PURE__*/_jsx(Flex, {
      className: S.flex,
      variant: "colS",
      children: /*#__PURE__*/_jsx(Selector, {
        className: S.selector,
        title: loading ? 'Loading...' : !selected ? 'Select Carmax Zone Name' : selectedTitle(selected),
        disabled: loading,
        values: options,
        loading: loading,
        onChange: onDropdownChange,
        valueKey: "name",
        value: selected,
        renderer: selectorRenderer,
        targetAttachment: "top right",
        checkStyle: "radio",
        stickyFilter: false,
        showFilter: true
      })
    })
  });
}